import { scan } from "@pdfking/rfunc"
import importer from "@pdfking/translations/importer"
import manifest from "@pdfking/translations/manifest"
import { reactive } from "vue"
import { settings_get } from "../state/settings"

type TranslationLibrary = Record<string, string>
type Translations = Record<string, TranslationLibrary>

const get_language = (lang?: string) =>
  lang || settings_get("settings", "language") || manifest.language

export const get_translations = (library: string, lang?: string) => {
  const language = get_language(lang)
  // @ts-expect-error - dynamic import structure
  const imp = importer[language][library]
  return imp().then((m: { default: TranslationLibrary }) => m.default)
}

export default (names?: string | string[], lang?: string): Translations => {
  const translations: Translations = reactive({})
  scan((library: string) => {
    translations[library] = {}
    get_translations(library, lang).then(res => (translations[library] = res))
  }, names || manifest.libraries)
  return translations
}
